import React, { useEffect, useState } from "react";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import axios from "axios";
import "../SubCostCenterMaster/SubCostCenterMaster.css"; // Assuming you have a CSS file for styles
const ExpenseCategory = () => {
  const [expenseCategory, setExpenseCategory] = useState([]);
  const [selectedExpenseCategory, setSelectedExpenseCategory] = useState("");
  const [expenseCategoryOptions, setExpenseCategoryOptions] = useState([]);
  const [expenseCategoryData, setExpenseCategoryData] = useState({
    expense_type: "",
    expense_type_id: "",
  });
  const [message, setMessage] = useState("");

  const baseAPI = process.env.REACT_APP_API_URL;

  const fetchExpenseCategory = async () => {
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.get(
        `${baseAPI}adminget/GetExpenseCategory?expense_category_id=0&expense_type_id=0`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      const allCenters = response.data?.data;
      if (Array.isArray(allCenters)) {
        const activeCenters = allCenters.filter(
          (item) => item.is_active === true
        );
        setExpenseCategory(activeCenters);
      } else {
        alert("Unexpected data format received.");
      }
    } catch (error) {
      console.error("Fetch error:", error.response || error);
      alert("Failed to fetch Expense Category.");
    }
  };

  const fetchexpenseCategoryOptions = async () => {
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.get(`${baseAPI}adminget/GetExpenseType`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      });

      const allCenters = response.data?.data;
      if (Array.isArray(allCenters)) {
        const activeCenters = allCenters.filter(
          (item) => item.is_active === true
        );
        setExpenseCategoryOptions(activeCenters);
      } else {
        alert("Unexpected data format received.");
      }
    } catch (error) {
      console.error("Fetch error:", error.response || error);
      alert("Failed to fetch Expense Category.");
    }
  };

  useEffect(() => {
    fetchExpenseCategory();
    fetchexpenseCategoryOptions();
  }, []);

  const handleSubmit = async () => {
    if (!expenseCategoryData.expense_type.trim()) {
      alert("Please enter Expense Category name.");
      return;
    }

    if (!selectedExpenseCategory) {
      alert("Please select a Cost Center.");
      return;
    }

    const payload = {
      expense_type: expenseCategoryData.expense_type.trim(),
      expense_type_id: parseInt(selectedExpenseCategory, 10),
    };

    console.log("Submitting payload:", payload); // ✅ Debug log

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));

      const response = await axios.post(
        `${baseAPI}adminPost/AddExpenseCategory`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        alert("Expense Category added successfully!");
        setExpenseCategoryData({ expense_type: "" });
        setSelectedExpenseCategory("");
        fetchExpenseCategory();
      } else {
        alert("Failed to add Expense Category.");
      }
    } catch (error) {
      console.error("Error adding Expense Category:", error);
      alert(`Error: ${error.response?.data?.message || "Unexpected error"}`);
    }
  };

  // Delete cost center (soft delete)
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this cost center?"))
      return;

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}adminPost/DeleteExpenseCategory`,
        { expense_category_id: id.toString() },
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Delete response:", response);

      if (response.status === 200 || response.status === 204) {
        alert("Expense Category deleted successfully.");
        fetchExpenseCategory();
      } else {
        alert("Failed to delete cost center.");
      }
    } catch (error) {
      console.error("Delete error:", error.response || error);
      alert(
        `Error: ${error.response?.data?.message || "Something went wrong."}`
      );
    }
  };

  const handleChange = (e) => {
    setExpenseCategoryData({
      ...expenseCategoryData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="d-flex flex-row app">
      <MiniDrawer />
      <div
        className="container-fluid"
        style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
      >
        <div
          className="d-flex flex-column w-100"
          style={{ backgroundColor: "#F4F4F4" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                Expense Category | <HomeOutlinedIcon />{" "}
                <span style={{ fontSize: "20px" }}>&gt; Master</span>
              </h1>
            </div>
            <div style={{ width: "8rem" }}>
              <select className="form-control" name="country">
                <option value="0">INDIA</option>
                <option value="1">DUBAI</option>
              </select>
            </div>
          </div>

          <Wrapper className="ViewLeadDetails mb-2">
            <div className="row">
              <div className="col-4">
                <div className="form-group mb-3">
                  <label>Expense Category:</label>
                  <input
                    type="text"
                    className="form-control"
                    name="expense_type"
                    value={expenseCategoryData.expense_type}
                    onChange={handleChange}
                    placeholder="Enter name"
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="form-group mb-3">
                  <label>Expense Type:</label>
                  <select
                    className="form-control"
                    value={selectedExpenseCategory}
                    onChange={(e) => setSelectedExpenseCategory(e.target.value)}
                  >
                    <option value="">-- Select --</option>
                    {expenseCategoryOptions.map((cc) => (
                      <option
                        key={cc.expense_type_id}
                        value={cc.expense_type_id}
                      >
                        {cc.expense_type}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-4">
<div className="form-group mb-3 text-end">
   <button className="btn btn-primary" onClick={handleSubmit}>
              Submit
            </button>
            </div>
            </div>
            </div>
            {message && <p className="mt-3">{message}</p>}
</Wrapper>
<Wrapper className="ViewLeadDetails">
            <h5 className="mt-4">Expense Category List</h5>
            <table className="table table-bordered">
              <thead className='SubCostCenterMaster-thead'>
                <tr>
                  <th>S.No</th>
                  <th>Expense Category</th>
                  <th>Expense Type</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody className='SubCostCenterMaster-tbody'>
                {Array.isArray(expenseCategory) &&
                expenseCategory.length > 0 ? (
                  expenseCategory.map((center, index) => (
                    <tr key={center.expense_category_id || index}>
                      <td>{index + 1}</td>
                      <td>{center.expense_type}</td>
                      <td>{center.expense_type_name}</td>
                      <td className='SubCostCenterMaster-td4'>
                        <button
                          className="btn btn-link text-danger p-0"
                          onClick={() =>
                            handleDelete(center.expense_category_id)
                          }
                          title="Delete"
                        >
                          <i className="fas fa-times"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No data found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </Wrapper>
        </div>
      </div>
    </div>
  );
};

export default ExpenseCategory;
